var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mapcontainer",attrs:{"id":"centerDiv"}},[_c('Map',{attrs:{"url":_vm.configUrl,"options":_vm.options},on:{"onload":_vm.onMapload}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }